import React from 'react'
import { Spinner } from '../Spinner'
import { StyledButton, ButtonContent, LeftAdHoc } from './styled'

const SKIN = {
  REGULAR: 'regular',
  OUTLINE: 'outline',
  TEXT: 'text'
}

interface Props {
  className: string
  children: React.ReactElement
  leftAdHoc: React.ReactElement
  onClick: (e: any) => void
  isDisabled: boolean
  isLoading: boolean
  skin: 'regular' | 'outline' | 'text'
  type: 'button' | 'submit'
}

export const Button: any = (props: Props) => {
  const {
    className,
    children,
    leftAdHoc,
    onClick,
    isDisabled,
    isLoading,
    skin,
    type
  } = props

  const hack: any = {
    type
  }

  return (
    <StyledButton
      {...hack}
      className={className}
      skin={skin}
      onClick={onClick}
      isLoading={isLoading}
      disabled={isDisabled || isLoading}
      hasLeftAdHoc={!!leftAdHoc}
    >
      {leftAdHoc && (
        <LeftAdHoc>
          {leftAdHoc}
        </LeftAdHoc>
      )}

      <ButtonContent>
        {children}
      </ButtonContent>

      {isLoading && (
        <Spinner size={18} />
      )}
    </StyledButton>
  )
}

Button.defaultProps = {
  type: 'button',
  skin: SKIN.REGULAR,
  isDisabled: false,
  isLoading: false
}

Button.SKIN = SKIN
Button.styled = StyledButton
Button.displayName = 'Button'
